import { render, staticRenderFns } from "./AsterWhatsapp.vue?vue&type=template&id=ee2c8220&"
import script from "./AsterWhatsapp.vue?vue&type=script&lang=js&"
export * from "./AsterWhatsapp.vue?vue&type=script&lang=js&"
import style0 from "./AsterWhatsapp.vue?vue&type=style&index=0&id=ee2c8220&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports